import { LDContext } from 'launchdarkly-react-client-sdk'
import User from 'singletons/User'

type LDContextWithCustomAttributes = LDContext & {
  license_types?: string[]
  license_states?: string[]
  payment_type?: string
  user_type?: 'provider'
}

type FlaggingAttributes = {
  isAttributesReady: boolean
  attributes: LDContextWithCustomAttributes
}

const useFlaggingAttributes = (): FlaggingAttributes => {
  return {
    isAttributesReady: !!User && !!User.providerId,
    attributes: {
      key: User.providerId,
      kind: 'user',
      anonymous: !User?.providerId,
      license_types: User?.provider?.uniqueLicenseTypes,
      license_states: User?.provider?.uniqueLicenseStates,
      payment_type: User?.provider?.paymentType,
      provider_type: User?.provider?.providerType,
      user_type: 'provider',
      _meta: {
        privateAttributes: ['license_types', 'license_states', 'payment_type', 'user_type', 'provider_type'],
      },
    },
  }
}

export default useFlaggingAttributes
